<template>
  <div class="section_tou flex-col justify-end">
    <div class="group_47 flex-row clearfix">
      <div class="section_3 leftfix">
        <img style="height: 60px" src="../../../static/img/LOGO.png" alt="" />
      </div>
      <div
        v-for="(item, index) in navList"
        :key="index"
        :class="['text', 'rightfix', 'childlist']"
      >
        <router-link :to="item.url" class="text-wrapper_29">
          <img
            v-if="item.url == currentNav"
            style="width: 18px;height: 10px; z-index: 999;"
            referrerpolicy="no-referrer"
            src="../../assets/newImage/椭圆 2.png"
          />
          <div v-else style="width: 18px;height: 10px; z-index: 999;"></div>
          <div
            :class="[item.url == currentNav && 'change', 'text_3']"
            @click="handleClick(item.url)"
          >
            {{ item.name }}
          </div>
          <div
            :class="[item.url == currentNav && 'change2', 'text_4']"
            @click="handleClick(item.url)"
          >
            {{ item.name_ }}
          </div>
          <div class="hovechild" v-if="item.children && item.children.length">
            <router-link
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
              :to="item.url + '?tb_class_id=' + child.value"
              class="child"
            >
              {{ child.label }}
            </router-link>
          </div>
        </router-link>
        <!-- <div
          class="image-wrapper_11 flex-row"
          :style="stylt_"
          v-if="item.url == currentNav"
        ></div> -->
      </div>
      <div class="buts">
        <img
          style="width: 70px;margin: 15px 0 0 15px;"
          referrerpolicy="no-referrer"
          src="@/assets/img/top_logo@1x.png"
          @click="gotoblibli"
        />
      </div>
      <div class="buts">
        <img
          style="width: 70px;margin: 15px 0 0 15px;"
          referrerpolicy="no-referrer"
          src="@/assets/img/xhs.png"
          @click="gotoxhs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getmeunclasslist } from "../../api/index";
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ec220e97268759013846786e2dc205d6";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
export default {
  data() {
    return {
      navList: [
        { url: "/index", name: "首页", name_: "ホーム" },
        {
          url: "/schoolCommon",
          name: "学校信息库",
          name_: "学校データ",
          show: true,
          children: [] // 初始化子菜单为空数组
        },
        { url: "/answers", name: "学校信息比对", name_: "学校情報" },
        { url: "/study", name: "留学资讯", name_: "留学ニュース" },
        { url: "/life", name: "留学生活", name_: "留学情報" },
        { url: "/regard", name: "关于我们", name_: "お問い合わせ" }
      ],
      currentNav: "", // 跟踪当前菜单,
      meunList: [],
      stylt_: "margin-left: 20px"
    };
  },
  mounted() {
    this.currentNav = "/" + this.$route.name;
    if (this.currentNav == "/index") {
      this.stylt_ = "margin-left: 20px";
    } else if (this.currentNav == "/schoolCommon") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/study") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/answers") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/life") {
      this.stylt_ = "margin-left:40px";
    } else if (this.currentNav == "/regard") {
      this.stylt_ = "margin-left:60px";
    }
    this.getmeunList();
  },
  methods: {
    gotoblibli() {
      window.open(
        "https://space.bilibili.com/3546692269902327?plat_id=1&share_from=space&share_medium=iphone&share_plat=ios&share_session_id=5DAF3541-3250-42CC-83CD-EBADE9679092&share_source=WEIXIN&share_tag=s_i&spmid=main.space-contribution.0.0&timestamp=1721096842&unique_k=7OBS83F"
      );
    },
    gotoxhs() {
      window.open(
        "https://www.xiaohongshu.com/user/profile/644df0e5000000002a0087fb?xhsshare=WeixinSession&appuid=644df0e5000000002a0087fb&apptime=1721365542&share_id=2fd2a0fe68af44a4a2d2b1d458a5ec71&wechatWid=feea6e33a775c9669527e67ae5338798&wechatOrigin=menu"
      );
    },
    handleClick(nav, data = null) {
      // const url = data ? nav + "?aaa=" + data : nav;
      // return console.log(url, nav)
      this.currentNav = nav;
      // this.$router.push({ name:url })
    },
    getmeunList() {
      getmeunclasslist().then(res => {
        this.meunList = res.data || [];
        // 将获取的子菜单数据添加到"学校信息库"的children中
        const schoolInfoIndex = this.navList.findIndex(
          item => item.url === "/schoolCommon"
        );
        if (schoolInfoIndex !== -1) {
          this.navList[schoolInfoIndex].children = this.meunList;
        }
      });
    }
  }
};
</script>

<style scoped>
/* 原有样式保持不变 */
.image_1 {
  width: 38px;
  height: 18px;
}

.image-wrapper_11 {
  width: 38px;
  height: 18px;
}

.group_47 {
  width: 1350px;
  height: 78px;
  margin: 0 auto;
}

.section_3 {
  width: 390px;
  height: 60px;
}

.text_3 {
  width: 115px;
  height: 20px;
  color: rgba(34, 34, 34, 0.8);
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.change {
  color: #f35022;
}
.change2 {
  color: #03a5f0 !important;
}

.text {
  border-right: 1px solid #f0f0f0;
  cursor: pointer;
  margin-top: 10px;
  position: relative; /* 添加相对定位 */
}

.text_4 {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  /* width: 90px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  text-transform: uppercase;
  font-family: microsoftyahei, "微软雅黑", SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 15px; */
}

.text-wrapper_29 {
  text-decoration: none;
  position: relative;
  display: block;
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  gap: 5px;
}

.hovechild {
  width: 128px;
  background-color: white;
  z-index: 999;
  position: absolute;
  top: 68px;
  left: 10px;
  display: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 5px 0;
}

.childlist:hover .hovechild {
  display: block;
}

.child {
  padding: 8px 15px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  display: block;
}

.child:hover {
  background-color: #f5f5f5;
  color: #0b6cb8;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.leftfix {
  float: left;
}

.rightfix {
  float: right;
}

.clearfix::after {
  content: "";
  display: block;
  clear: both;
}

.buts {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue